import { constants } from '@bedc/constants';

import { Request } from '../../../../api/admin/organization/search/Request';

import { SearchDataTableType } from './SearchDataTableType';

export const OrganizationAdminType = SearchDataTableType({
	request: Request,
	columnFields: constants.organization.search.adminColumnFields,
	filterIds: constants.organization.search.filterIds,
});
